<template>
<div>
  <el-dialog title="创建用户" :visible.sync="alterShow.show"
             @close="closeDialog()"
             @opened="Init()"
             width="250px" height="300px"
             :close-on-click-modal="false"
             :append-to-body="true"
             center id="addProjectBox">
    <el-form  label-width="80px" :rules="rules" ref="ruleForm" :model="formInfo">
      <el-form-item label="以前密码" prop="oldpwd">
        <el-input show-password v-model="formInfo.oldpwd"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newpwd" >
        <el-input show-password v-model="formInfo.newpwd" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="reppwd">
        <el-input show-password v-model="formInfo.reppwd" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('ruleForm')">确定</el-button>
      </el-form-item>

    </el-form>

  </el-dialog>

</div>
</template>

<script>
    export default {
        name: "alterPassword",
        props:{
            alterShow:Object,
            userId:Number
        },
        data(){
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.formInfo.reppwd !== '') {
                        this.$refs.ruleForm.validateField('reppwd');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.formInfo.newpwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return{
            formInfo:{
                userId:'',
                oldpwd:'',
                newpwd:"",
                reppwd:''
            },
                rules:{
                    oldpwd: [
                        { required: true, message: '请输入原密码', trigger: 'blur' },
                    ],
                    newpwd: [
                        { required: true,validator: validatePass, trigger: 'blur' }
                    ],
                    reppwd:[
                        {required: true,validator: validatePass2, trigger: 'blur' }
                    ],
                }
        }
        },
        methods:{
            Init(){
                this.formInfo.userId=this.userId
            },
            closeDialog(){
                this.formInfo.userId=''
                this.formInfo.oldpwd=''
                this.formInfo.newpwd=''
                this.formInfo.reppwd=''
            },
        //    提交按钮
            onSubmit(ruleForm){
                this.$refs[ruleForm].validate((valid) => {
                    if (valid) {
                        this.$axios.post('/api/monitor/user/changePwd',this.formInfo).then(res => {
                            if(res.data.status==200){
                                this.$message({
                                    type:"success",
                                    message:"修改密码成功",
                                    showClose: true
                                });
                                this.alterShow.show = false;
                                this.$emit('update');
                            }else{
                                this.$message.error(res.data.message)
                            }
                        });
                    } else {
                        return false;
                    }
                })
            }
        }
    }
</script>

<style>
  .el-dialog__header {
    text-align: center;
    padding: 20px 30px 10px;
    /*background-image: url('../../assets/img/modal_bg.png')*/
    background: linear-gradient(
      -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%) !important;
    border-radius: 2.5px 2.5px 0px 0px;
    transition: unset;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }

  .el-dialog__title {
    text-align: center;
    font-size: 18px;
    color: #fff;
  }

  .el-form-item{
    margin: 20px 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/systemSetting/alterPassword.vue